import { Toaster as SonnerToaster, toast } from "sonner";
import { Icon } from "./icon";

/** sonner styled as the token `.toast` (navy pill, toned icon), bottom-right like the mockups. */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      gap={8}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "toast w-[356px] max-w-[calc(100vw-2rem)]",
          title: "text-sm font-medium",
          description: "mt-0.5 text-xs text-ink-300",
          actionButton: "btn btn-primary btn-sm ml-auto",
          cancelButton: "btn btn-ghost btn-sm text-ink-300",
        },
      }}
      icons={{
        success: <Icon name="check-circle" className="text-mint-500" />,
        info: <Icon name="info" className="text-brand-400" />,
        warning: <Icon name="alert-triangle" className="text-signal-500" />,
        error: <Icon name="alert-circle" className="text-rose-500" />,
      }}
    />
  );
}

export { toast };
